/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
 */
import sy from "@/pages/sy/index.vue";
import syInfo from "@/pages/sy/info/index.vue";
export default [
  {
    path: "/sy",
    name: "sy",
    component: sy,
    meta: {
      title: "溯源",
      noCache: true,
      affix: false,
      path: ""
    }
  },
  {
    path: "/syInfo",
    name: "syInfo",
    component: syInfo,
    meta: {
      title: "溯源详情",
      noCache: true,
      affix: false,
      path: ""
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/sy.js